// Date helpers used across UI surfaces. Asia/Kolkata is the canonical tenant TZ.

const istFormatter = new Intl.DateTimeFormat("en-IN", {
  day: "numeric",
  month: "short",
  year: "numeric",
  timeZone: "Asia/Kolkata",
});

const istLongFormatter = new Intl.DateTimeFormat("en-IN", {
  day: "numeric",
  month: "long",
  year: "numeric",
  timeZone: "Asia/Kolkata",
});

const istDateTimeFormatter = new Intl.DateTimeFormat("en-IN", {
  day: "numeric",
  month: "short",
  year: "numeric",
  hour: "numeric",
  minute: "2-digit",
  timeZone: "Asia/Kolkata",
});

const istRelative = new Intl.RelativeTimeFormat("en-IN", { numeric: "auto" });

export function formatIndianDate(value: string | number | Date): string {
  return istFormatter.format(new Date(value));
}

export function formatIndianDateLong(value: string | number | Date): string {
  return istLongFormatter.format(new Date(value));
}

export function formatIndianDateTime(value: string | number | Date): string {
  return istDateTimeFormatter.format(new Date(value));
}

const SECOND = 1_000;
const MINUTE = 60 * SECOND;
const HOUR = 60 * MINUTE;
const DAY = 24 * HOUR;

export function formatRelative(value: string | number | Date, now: Date = new Date()): string {
  const diff = new Date(value).getTime() - now.getTime();
  const absDiff = Math.abs(diff);

  if (absDiff < MINUTE) return istRelative.format(Math.round(diff / SECOND), "second");
  if (absDiff < HOUR) return istRelative.format(Math.round(diff / MINUTE), "minute");
  if (absDiff < DAY) return istRelative.format(Math.round(diff / HOUR), "hour");
  if (absDiff < 30 * DAY) return istRelative.format(Math.round(diff / DAY), "day");
  if (absDiff < 365 * DAY) return istRelative.format(Math.round(diff / (30 * DAY)), "month");
  return istRelative.format(Math.round(diff / (365 * DAY)), "year");
}

export function addDays(value: string | number | Date, days: number): Date {
  const d = new Date(value);
  d.setDate(d.getDate() + days);
  return d;
}

export function isExpiringWithin(
  value: string | number | Date,
  days: number,
  now: Date = new Date(),
): boolean {
  const target = new Date(value).getTime();
  return target - now.getTime() <= days * DAY;
}
